import * as actionTypes from "./actionTypes";
import { LOGOUT_USER } from "../user/actionTypes";

const initialState = {
    topCustomerList: { topCustomers: [], total: 0, pageSize: 0, error: null, loading: false },
    dailyBalanceList: {
        dailyBalance: [],
        totalBought: 0,
        totalCreditNotes: 0,
        totalCashPayed: 0,
        totalCardPayed: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    employeesBalanceList: {
        employeesBalance: [],
        totalSell: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    categoryBalanceList: {
        categoryBalance: [],
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    categorySellsBalanceList: {
        categorySellsBalance: [],
        totalBought: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    paymentDetailsBalanceList: {
        paymentDetailsBalance: [],
        totalBought: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    paymentTypesBalanceList: {
        paymentTypesBalance: [],
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    offerDetailsBalanceList: {
        serviceDetailsBalance: [],
        totalBought: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    serviceDetailsBalanceList: {
        serviceDetailsBalance: [],
        totalBought: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    serviceNamesBalanceList: {
        serviceNamesBalance: [],
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    daysBalanceList: {
        daysBalance: [],
        totalBought: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    customersBalanceList: {
        customersBalance: [],
        totalBought: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    productDetailsBalanceList: {
        productDetailsBalance: [],
        totalBought: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    productNamesBalanceList: {
        productNamesBalance: [],
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    productsInList: { productsIn: [], total: 0, pageSize: 0, error: null, loading: false },
    internalConsumptionList: {
        internalConsumption: [],
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    regularizationsList: {
        regularizations: [],
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    productsDevolutionsList: {
        productsDevolutions: [],
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    inventoryList: { inventory: [], total: 0, pageSize: 0, error: null, loading: false },
    receiptBalanceList: { receiptBalance: [], total: 0, pageSize: 0, error: null, loading: false },
    receiptSellsBalanceList: {
        receiptSellsBalance: [],
        totalBought: 0,
        total: 0,
        pageSize: 0,
        error: null,
        loading: false
    },
    detailedSellsReport: { value: undefined, loading: false, error: undefined }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_TOP_CUSTOMERS:
            return {
                ...state,
                topCustomerList: {
                    ...state.topCustomerList,
                    error: null,
                    loading: true
                }
            };

        case actionTypes.FETCH_TOP_CUSTOMERS_SUCCESS:
            return {
                ...state,
                topCustomerList: {
                    topCustomers: action.payload.topCustomers,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };

        case actionTypes.FETCH_TOP_CUSTOMERS_FAILURE:
            return {
                ...state,
                topCustomerList: {
                    topCustomers: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };

        case actionTypes.RESET_TOP_CUSTOMERS:
            return { ...state, topCustomerList: initialState.topCustomerList };

        case actionTypes.FETCH_DAILY_BALANCE:
            return {
                ...state,
                dailyBalanceList: {
                    ...state.dailyBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_DAILY_BALANCE_SUCCESS:
            return {
                ...state,
                dailyBalanceList: {
                    dailyBalance: action.payload.dailyBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    totalCreditNotes: action.payload.totalCreditNotes,
                    totalCashPayed: action.payload.totalCashPayed,
                    totalCardPayed: action.payload.totalCardPayed,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_DAILY_BALANCE_FAILURE:
            return {
                ...state,
                dailyBalanceList: {
                    dailyBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_DAILY_BALANCE:
            return {
                ...state,
                employeesBalanceList: initialState.employeesBalanceList
            };

        case actionTypes.FETCH_EMPLOYEES_BALANCE:
            return {
                ...state,
                employeesBalanceList: {
                    ...state.employeesBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_EMPLOYEES_BALANCE_SUCCESS:
            return {
                ...state,
                employeesBalanceList: {
                    employeesBalance: action.payload.employeesBalance,
                    totalSell: action.payload.totalSell,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_EMPLOYEES_BALANCE_FAILURE:
            return {
                ...state,
                employeesBalanceList: {
                    employeesBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_EMPLOYEES_BALANCE:
            return {
                ...state,
                employeesBalanceList: initialState.employeesBalanceList
            };

        case actionTypes.FETCH_CATEGORY_BALANCE:
            return {
                ...state,
                categoryBalanceList: {
                    ...state.categoryBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_CATEGORY_BALANCE_SUCCESS:
            return {
                ...state,
                categoryBalanceList: {
                    categoryBalance: action.payload.categoryBalance,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_CATEGORY_BALANCE_FAILURE:
            return {
                ...state,
                categoryBalanceList: {
                    categoryBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_CATEGORY_BALANCE:
            return {
                ...state,
                categoryBalanceList: initialState.categoryBalanceList
            };

        case actionTypes.FETCH_CATEGORY_SELLS_BALANCE:
            return {
                ...state,
                categorySellsBalanceList: {
                    ...state.categorySellsBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_CATEGORY_SELLS_BALANCE_SUCCESS:
            return {
                ...state,
                categorySellsBalanceList: {
                    categorySellsBalance: action.payload.categorySellsBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_CATEGORY_SELLS_BALANCE_FAILURE:
            return {
                ...state,
                categorySellsBalanceList: {
                    categorySellsBalance: [],
                    totalBought: 0,
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_CATEGORY_SELLS_BALANCE:
            return {
                ...state,
                categorySellsBalanceList: initialState.categorySellsBalanceList
            };
        case actionTypes.FETCH_RECEIPT_BALANCE:
            return {
                ...state,
                receiptBalanceList: {
                    ...state.receiptBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_RECEIPT_BALANCE_SUCCESS:
            return {
                ...state,
                receiptBalanceList: {
                    receiptBalance: action.payload.receiptBalance,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_RECEIPT_BALANCE_FAILURE:
            return {
                ...state,
                receiptBalanceList: {
                    receiptBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_RECEIPT_BALANCE:
            return {
                ...state,
                receiptBalanceList: initialState.receiptBalanceList
            };

        case actionTypes.FETCH_RECEIPT_SELLS_BALANCE:
            return {
                ...state,
                receiptSellsBalanceList: {
                    ...state.receiptSellsBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_RECEIPT_SELLS_BALANCE_SUCCESS:
            return {
                ...state,
                receiptSellsBalanceList: {
                    receiptSellsBalance: action.payload.receiptSellsBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_RECEIPT_SELLS_BALANCE_FAILURE:
            return {
                ...state,
                receiptSellsBalanceList: {
                    receiptSellsBalance: [],
                    totalBought: 0,
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_RECEIPT_SELLS_BALANCE:
            return {
                ...state,
                receiptSellsBalanceList: initialState.receiptSellsBalanceList
            };
        case actionTypes.FETCH_PAYMENT_DETAILS_BALANCE:
            return {
                ...state,
                paymentDetailsBalanceList: {
                    ...state.paymentDetailsBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_PAYMENT_DETAILS_BALANCE_SUCCESS:
            return {
                ...state,
                paymentDetailsBalanceList: {
                    paymentDetailsBalance: action.payload.paymentDetailsBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_PAYMENT_DETAILS_BALANCE_FAILURE:
            return {
                ...state,
                paymentDetailsBalanceList: {
                    paymentDetailsBalance: [],
                    totalBought: 0,
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_PAYMENT_DETAILS_BALANCE:
            return {
                ...state,
                paymentDetailsBalanceList: initialState.paymentDetailsBalanceList
            };

        case actionTypes.FETCH_PAYMENT_TYPES_BALANCE:
            return {
                ...state,
                paymentTypesBalanceList: {
                    ...state.paymentTypesBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_PAYMENT_TYPES_BALANCE_SUCCESS:
            return {
                ...state,
                paymentTypesBalanceList: {
                    paymentTypesBalance: action.payload.paymentTypesBalance,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_PAYMENT_TYPES_BALANCE_FAILURE:
            return {
                ...state,
                paymentTypesBalanceList: {
                    paymentTypesBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_PAYMENT_TYPES_BALANCE:
            return {
                ...state,
                paymentTypesBalanceList: initialState.paymentTypesBalanceList
            };

        case actionTypes.FETCH_OFFER_DETAILS_BALANCE:
            return {
                ...state,
                offerDetailsBalanceList: {
                    ...state.offerDetailsBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_OFFER_DETAILS_BALANCE_SUCCESS:
            return {
                ...state,
                offerDetailsBalanceList: {
                    offerDetailsBalance: action.payload.offerDetailsBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_OFFER_DETAILS_BALANCE_FAILURE:
            return {
                ...state,
                offerDetailsBalanceList: {
                    offerDetailsBalance: [],
                    totalBought: 0,
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_OFFER_DETAILS_BALANCE:
            return {
                ...state,
                offerDetailsBalanceList: initialState.offerDetailsBalanceList
            };

        case actionTypes.FETCH_SERVICE_DETAILS_BALANCE:
            return {
                ...state,
                serviceDetailsBalanceList: {
                    ...state.serviceDetailsBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_SERVICE_DETAILS_BALANCE_SUCCESS:
            return {
                ...state,
                serviceDetailsBalanceList: {
                    serviceDetailsBalance: action.payload.serviceDetailsBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_SERVICE_DETAILS_BALANCE_FAILURE:
            return {
                ...state,
                serviceDetailsBalanceList: {
                    serviceDetailsBalance: [],
                    totalBought: 0,
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_SERVICE_DETAILS_BALANCE:
            return {
                ...state,
                serviceDetailsBalanceList: initialState.serviceDetailsBalanceList
            };

        case actionTypes.FETCH_SERVICE_NAMES_BALANCE:
            return {
                ...state,
                serviceNamesBalanceList: {
                    ...state.serviceNamesBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_SERVICE_NAMES_BALANCE_SUCCESS:
            return {
                ...state,
                serviceNamesBalanceList: {
                    serviceNamesBalance: action.payload.serviceNamesBalance,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_SERVICE_NAMES_BALANCE_FAILURE:
            return {
                ...state,
                serviceNamesBalanceList: {
                    serviceNamesBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_SERVICE_NAMES_BALANCE:
            return {
                ...state,
                serviceNamesBalanceList: initialState.serviceNamesBalanceList
            };

        case actionTypes.FETCH_DAYS_BALANCE:
            return {
                ...state,
                daysBalanceList: {
                    ...state.daysBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_DAYS_BALANCE_SUCCESS:
            return {
                ...state,
                daysBalanceList: {
                    daysBalance: action.payload.daysBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_DAYS_BALANCE_FAILURE:
            return {
                ...state,
                daysBalanceList: {
                    daysBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_DAYS_BALANCE:
            return {
                ...state,
                daysBalanceList: initialState.daysBalanceList
            };

        case actionTypes.FETCH_CUSTOMERS_BALANCE:
            return {
                ...state,
                customersBalanceList: {
                    ...state.customersBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_CUSTOMERS_BALANCE_SUCCESS:
            return {
                ...state,
                customersBalanceList: {
                    customersBalance: action.payload.customersBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_CUSTOMERS_BALANCE_FAILURE:
            return {
                ...state,
                customersBalanceList: {
                    customersBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_CUSTOMERS_BALANCE:
            return {
                ...state,
                customersBalanceList: initialState.customersBalanceList
            };

        case actionTypes.FETCH_PRODUCT_DETAILS_BALANCE:
            return {
                ...state,
                productDetailsBalanceList: {
                    ...state.productDetailsBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_PRODUCT_DETAILS_BALANCE_SUCCESS:
            return {
                ...state,
                productDetailsBalanceList: {
                    productDetailsBalance: action.payload.productDetailsBalance,
                    totalBought: action.payload.totalBought,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_PRODUCT_DETAILS_BALANCE_FAILURE:
            return {
                ...state,
                productDetailsBalanceList: {
                    productDetailsBalance: [],
                    totalBought: 0,
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_PRODUCT_DETAILS_BALANCE:
            return {
                ...state,
                productDetailsBalanceList: initialState.productDetailsBalanceList
            };

        case actionTypes.FETCH_PRODUCT_NAMES_BALANCE:
            return {
                ...state,
                productNamesBalanceList: {
                    ...state.productNamesBalanceList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_PRODUCT_NAMES_BALANCE_SUCCESS:
            return {
                ...state,
                productNamesBalanceList: {
                    productNamesBalance: action.payload.productNamesBalance,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_PRODUCT_NAMES_BALANCE_FAILURE:
            return {
                ...state,
                productNamesBalanceList: {
                    productNamesBalance: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_PRODUCT_NAMES_BALANCE:
            return {
                ...state,
                productNamesBalanceList: initialState.productNamesBalanceList
            };

        case actionTypes.FETCH_PRODUCTS_IN:
            return {
                ...state,
                productsInList: {
                    ...state.productsInList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_PRODUCTS_IN_SUCCESS:
            return {
                ...state,
                productsInList: {
                    productsIn: action.payload.productsIn,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_PRODUCTS_IN_FAILURE:
            return {
                ...state,
                productsInList: {
                    productsIn: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_PRODUCTS_IN:
            return {
                ...state,
                productsInList: initialState.productsInList
            };

        case actionTypes.FETCH_INTERNAL_CONSUMPTION:
            return {
                ...state,
                internalConsumptionList: {
                    ...state.internalConsumptionList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_INTERNAL_CONSUMPTION_SUCCESS:
            return {
                ...state,
                internalConsumptionList: {
                    internalConsumption: action.payload.internalConsumption,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_INTERNAL_CONSUMPTION_FAILURE:
            return {
                ...state,
                internalConsumptionList: {
                    internalConsumption: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_INTERNAL_CONSUMPTION:
            return {
                ...state,
                internalConsumptionList: initialState.internalConsumptionList
            };

        case actionTypes.FETCH_REGULARIZATIONS:
            return {
                ...state,
                regularizationsList: {
                    ...state.regularizationsList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_REGULARIZATIONS_SUCCESS:
            return {
                ...state,
                regularizationsList: {
                    regularizations: action.payload.regularizations,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_REGULARIZATIONS_FAILURE:
            return {
                ...state,
                regularizationsList: {
                    regularizations: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_REGULARIZATIONS:
            return {
                ...state,
                regularizationsList: initialState.regularizationsList
            };

        case actionTypes.FETCH_PRODUCTS_DEVOLUTIONS:
            return {
                ...state,
                productsDevolutionsList: {
                    ...state.productsDevolutionsList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_PRODUCTS_DEVOLUTIONS_SUCCESS:
            return {
                ...state,
                productsDevolutionsList: {
                    productsDevolutions: action.payload.productsDevolutions,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_PRODUCTS_DEVOLUTIONS_FAILURE:
            return {
                ...state,
                productsDevolutionsList: {
                    productsDevolutions: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_PRODUCTS_DEVOLUTIONS:
            return {
                ...state,
                productsDevolutionsList: initialState.productsDevolutionsList
            };

        case actionTypes.FETCH_INVENTORY:
            return {
                ...state,
                inventoryList: {
                    ...state.inventoryList,
                    error: null,
                    loading: true
                }
            };
        case actionTypes.FETCH_INVENTORY_SUCCESS:
            return {
                ...state,
                inventoryList: {
                    inventory: action.payload.inventory,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            };
        case actionTypes.FETCH_INVENTORY_FAILURE:
            return {
                ...state,
                inventoryList: {
                    inventory: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            };
        case actionTypes.RESET_INVENTORY:
            return {
                ...state,
                inventoryList: initialState.inventoryList
            };

        case actionTypes.FETCH_DETAILED_SELLS:
            return {
                ...state,
                detailedSellsReport: { value: undefined, loading: true, error: undefined }
            };

        case actionTypes.FETCH_DETAILED_SELLS_SUCCESS:
            return {
                ...state,
                detailedSellsReport: { value: action.payload.value, loading: false, error: undefined }
            };

        case actionTypes.FETCH_DETAILED_SELLS_FAILURE:
            return {
                ...state,
                detailedSellsReport: { value: undefined, loading: false, error: action.payload.error }
            };

        case actionTypes.RESET_FETCH_DETAILED_SELLS:
            return {
                ...state,
                detailedSellsReport: initialState.detailedSellsReport
            };

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/report/reducer.js